<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<wa-button [routerLink]="['/plugins']" appearance="plain" variant="neutral">Back to Plugins</wa-button>
		<wa-card appearance="outlined">
			<div class="wa-stack wa-gap-m">
				<div class="wa-stack wa-gap-s">
					<h1 waHeading="xl" waText>Angular Plugin</h1>
					<p waBody="m" waText>Generates complete Angular 21 TypeScript projects from Java annotations &mdash; components, routing, modules, environment config, STOMP/WebSocket bridge &mdash; and serves the SPA via Vert.x with fallback routing. Annotate your Java classes with &#64;NgApp, &#64;NgComponent, &#64;NgRoutable, &#64;NgDataService &mdash; the compiler produces .ts files, angular.json, package.json, tsconfig.json, routing modules, and environment config.</p>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">Angular 21</wa-tag>
						<wa-tag pill variant="neutral">Vert.x 5</wa-tag>
						<wa-tag pill variant="neutral">STOMP/WebSocket</wa-tag>
						<wa-tag pill variant="neutral">TypeScript 5</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>COORDINATES &amp; MODULE</div>
					<p waBody="s" waText>Maven: com.jwebmp.plugins:angular</p>
					<p waBody="s" waText>JPMS Module: com.jwebmp.core.angular</p>
					<p waBody="s" waText>Built on: Angular 20</p>
				</div>
				<wa-details summary="Installation">
					<div class="wa-stack wa-gap-xs">
						@if (!useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Maven</div>
								<markdown [data]="mdContent_524" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
						@if (useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Gradle &#40;Kotlin DSL&#41;</div>
								<markdown [data]="mdContent_525" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-m">
					<h2 waHeading="l" waText>Components &#40;7&#41;</h2>
					<p waBody="m" waText>Click any component to see its full API &mdash; properties, constructors, methods, events, slots, and examples.</p>
					<div class="wa-grid wa-gap-s" style="--min-column-size:18rem;">
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>NGApplication</h4>
								<p waBody="s" waColorText="quiet" waText>Base class for &#64;NgApp &mdash; defines the Angular application</p>
								<div class="wa-cluster wa-gap-xs"></div>
								<wa-button [routerLink]="['/plugins/angular/ngapplication']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>NgIf</h4>
								<p waBody="s" waColorText="quiet" waText>Angular 17+ &#64;if control-flow component</p>
								<div class="wa-cluster wa-gap-xs"></div>
								<wa-button [routerLink]="['/plugins/angular/ng-if']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>NgFor</h4>
								<p waBody="s" waColorText="quiet" waText>Angular 17+ &#64;for control-flow component</p>
								<div class="wa-cluster wa-gap-xs"></div>
								<wa-button [routerLink]="['/plugins/angular/ng-for']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>RouterLink</h4>
								<p waBody="s" waColorText="quiet" waText>Router link with &#91;routerLink&#93;, &#91;queryParams&#93;, &#91;state&#93; binding</p>
								<div class="wa-cluster wa-gap-xs"></div>
								<wa-button [routerLink]="['/plugins/angular/router-link']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>RouterOutlet</h4>
								<p waBody="s" waColorText="quiet" waText>Angular router outlet placeholder</p>
								<div class="wa-cluster wa-gap-xs"></div>
								<wa-button [routerLink]="['/plugins/angular/router-outlet']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>TypeScriptCompiler</h4>
								<p waBody="s" waColorText="quiet" waText>Orchestrates .ts code generation from Java annotations</p>
								<div class="wa-cluster wa-gap-xs"></div>
								<wa-button [routerLink]="['/plugins/angular/type-script-compiler']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>StompServer</h4>
								<p waBody="s" waColorText="quiet" waText>STOMP/WebSocket bridge at /eventbus</p>
								<div class="wa-cluster wa-gap-xs"></div>
								<wa-button [routerLink]="['/plugins/angular/stomp-server']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
					</div>
				</div>
				<wa-details summary="Features (12)">
					<div class="wa-stack wa-gap-xs">
						<p waBody="s" waColorText="quiet" waText>TypeScript code generation &mdash; TypeScriptCompiler orchestrates ComponentProcessor, AngularModuleProcessor, AssetManager, DependencyManager, and CodeValidator</p>
						<p waBody="s" waColorText="quiet" waText>SPA hosting via Vert.x &mdash; serves dist/ with StaticHandler, /assets/&#42; mount, SPA fallback for Angular Router</p>
						<p waBody="s" waColorText="quiet" waText>STOMP/WebSocket bridge &mdash; StompServer at /eventbus with v10/v11/v12.stomp sub-protocols, 10s/50s heartbeats</p>
						<p waBody="s" waColorText="quiet" waText>Reactive message processing &mdash; inbound STOMP messages dispatched to IWebSocketMessageReceiver listeners</p>
						<p waBody="s" waColorText="quiet" waText>Built-in WebSocket receivers &mdash; ajax, data, dataSend, AddToWebSocketGroup, RemoveFromWebSocketGroup actions</p>
						<p waBody="s" waColorText="quiet" waText>Angular control-flow components &mdash; NgIf, NgIfElse, NgFor, NgForEmpty, NgLet for Angular 17+ template syntax</p>
						<p waBody="s" waColorText="quiet" waText>Routing &mdash; AngularRoutingModule scans &#64;NgRoutable classes, builds DefinedRoute tree, generates RouterModule.forRoot&#40;routes&#41;</p>
						<p waBody="s" waColorText="quiet" waText>Environment module &mdash; generates TypeScript const environment from Java EnvironmentOptions</p>
						<p waBody="s" waColorText="quiet" waText>Angular project scaffolding &mdash; generates angular.json, package.json, tsconfig.json, app.config.json</p>
						<p waBody="s" waColorText="quiet" waText>RouterLink component with &#91;routerLink&#93;, &#91;queryParams&#93;, &#91;state&#93; binding</p>
						<p waBody="s" waColorText="quiet" waText>WebSocket group management &mdash; WebSocketGroupsDirective for declarative group subscription</p>
						<p waBody="s" waColorText="quiet" waText>NPM resource locator &mdash; discovers and serves bundled node&#95;modules resources from classpath</p>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Examples (1)">
					<div class="wa-stack wa-gap-m">
						<div class="wa-stack wa-gap-xs">
							<h4 waHeading="s" waText>Define an Angular App</h4>
							<p waBody="s" waColorText="quiet" waText>Create an Angular 21 application with a boot component and routable page.</p>
							<markdown [data]="mdContent_526" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
						</div>
					</div>
				</wa-details>
				<wa-details open summary="Quick Start">
					<markdown [data]="mdContent_527" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="SPI Extension Point Details (5)">
					<div class="wa-stack wa-gap-s">
						<div class="wa-stack wa-gap-xs">
							<div class="wa-cluster wa-gap-xs">
								<wa-tag pill variant="success">VertxRouterConfigurator</wa-tag>
								<wa-tag pill variant="neutral">provides</wa-tag>
							</div>
							<p waBody="s" waColorText="quiet" waText>Registers SPA routes, /assets/&#42;, and fallback routing for Angular Router</p>
						</div>
						<div class="wa-stack wa-gap-xs">
							<div class="wa-cluster wa-gap-xs">
								<wa-tag pill variant="success">IWebSocketMessageReceiver</wa-tag>
								<wa-tag pill variant="neutral">provides</wa-tag>
							</div>
							<p waBody="s" waColorText="quiet" waText>Built-in receivers for ajax, data, dataSend, AddToWebSocketGroup, RemoveFromWebSocketGroup</p>
						</div>
						<div class="wa-stack wa-gap-xs">
							<div class="wa-cluster wa-gap-xs">
								<wa-tag pill variant="success">IGuiceModule</wa-tag>
								<wa-tag pill variant="neutral">provides</wa-tag>
							</div>
							<p waBody="s" waColorText="quiet" waText>Registers Angular-specific Guice bindings and WebSocket infrastructure</p>
						</div>
						<div class="wa-stack wa-gap-xs">
							<div class="wa-cluster wa-gap-xs">
								<wa-tag pill variant="brand">AngularScanPackages</wa-tag>
								<wa-tag pill variant="neutral">uses</wa-tag>
							</div>
							<p waBody="s" waColorText="quiet" waText>Discovered to determine which Java packages to scan for Angular annotations</p>
						</div>
						<div class="wa-stack wa-gap-xs">
							<div class="wa-cluster wa-gap-xs">
								<wa-tag pill variant="brand">TypescriptIndexPageConfigurator</wa-tag>
								<wa-tag pill variant="neutral">uses</wa-tag>
							</div>
							<p waBody="s" waColorText="quiet" waText>Discovered for cross-plugin asset integration</p>
						</div>
					</div>
				</wa-details>
				<wa-details open summary="SPI Extension Points">
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">provides IGuiceScanModuleInclusions</wa-tag>
							<wa-tag pill variant="success">provides IGuiceConfigurator</wa-tag>
							<wa-tag pill variant="success">provides IGuicePreStartup</wa-tag>
							<wa-tag pill variant="success">provides IGuiceModule</wa-tag>
							<wa-tag pill variant="success">provides VertxRouterConfigurator</wa-tag>
							<wa-tag pill variant="success">provides VertxHttpServerOptionsConfigurator</wa-tag>
							<wa-tag pill variant="success">provides IGuicePostStartup</wa-tag>
							<wa-tag pill variant="success">provides IOnComponentConfigured</wa-tag>
							<wa-tag pill variant="success">provides IOnClickService</wa-tag>
							<wa-tag pill variant="success">provides IWebSocketMessageReceiver</wa-tag>
						</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">uses AngularScanPackages</wa-tag>
							<wa-tag pill variant="brand">uses RenderedAssets</wa-tag>
							<wa-tag pill variant="brand">uses NpmrcConfigurator</wa-tag>
							<wa-tag pill variant="brand">uses WebSocketGroupAdd</wa-tag>
							<wa-tag pill variant="brand">uses TypescriptIndexPageConfigurator</wa-tag>
							<wa-tag pill variant="brand">uses IPageConfigurator</wa-tag>
							<wa-tag pill variant="brand">uses IWebSocketAuthDataProvider</wa-tag>
						</div>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Properties (2)">
					<table style="border-collapse:collapse;width:100%;">
						<thead>
							<tr style="border-bottom:2px solid var(--wa-color-neutral-200);">
								<th style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);text-align:left;">Property</th>
								<th style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);text-align:left;">Type</th>
								<th style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);text-align:left;">Default</th>
								<th style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);text-align:left;">Description</th>
							</tr>
						</thead>
						<tbody>
							<tr style="border-bottom:1px solid var(--wa-color-neutral-100);">
								<td style="color:var(--wa-color-brand-normal);font-family:var(--wa-font-mono);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);">EnvironmentOptions</td>
								<td style="color:var(--wa-color-text-quiet);font-family:var(--wa-font-mono);font-size:var(--wa-font-size-xs);padding:var(--wa-spacing-small);">class</td>
								<td style="color:var(--wa-color-text-quiet);font-family:var(--wa-font-mono);font-size:var(--wa-font-size-xs);padding:var(--wa-spacing-small);">–</td>
								<td style="font-size:var(--wa-font-size-s);padding:var(--wa-spacing-small);">Java object serialized as TypeScript const environment — app name, API URLs, feature flags</td>
							</tr>
							<tr style="border-bottom:1px solid var(--wa-color-neutral-100);">
								<td style="color:var(--wa-color-brand-normal);font-family:var(--wa-font-mono);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);">StompServer heartbeat</td>
								<td style="color:var(--wa-color-text-quiet);font-family:var(--wa-font-mono);font-size:var(--wa-font-size-xs);padding:var(--wa-spacing-small);">int/int</td>
								<td style="color:var(--wa-color-text-quiet);font-family:var(--wa-font-mono);font-size:var(--wa-font-size-xs);padding:var(--wa-spacing-small);">10s/50s</td>
								<td style="font-size:var(--wa-font-size-s);padding:var(--wa-spacing-small);">Heartbeat intervals for STOMP WebSocket connection</td>
							</tr>
						</tbody>
					</table>
				</wa-details>
				<wa-details open summary="Prerequisites">
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25 LTS</wa-tag>
						<wa-tag pill variant="neutral">Maven 3.9+</wa-tag>
						<wa-tag pill variant="neutral">Node.js 18+</wa-tag>
						<wa-tag pill variant="neutral">Angular 21+</wa-tag>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="neutral">Upstream: https://angular.dev/</wa-tag>
					<wa-tag pill variant="neutral">Source: https://github.com/JWebMP/Angular</wa-tag>
				</div>
			</div>
		</wa-card>
	</div>
</div>